import MemberCards from './MemberCards.component';

export default MemberCards;